import React, { useMemo, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { instituteNavigation, superNavigation } from '../config/navigation';
import { titleCase } from '../utils/format';
import FloatingSupportChat from './FloatingSupportChat';
import SupportPresenceBridge from './SupportPresenceBridge';

function resolveTitle(pathname, navigation) {
  for (const item of navigation) {
    if (item.path === pathname) return item.label;
    const child = item.children?.find((entry) => entry.path === pathname);
    if (child) return child.label;
  }
  const last = pathname.split('/').filter(Boolean).pop() || 'Dashboard';
  return titleCase(last);
}

export default function AppShell({ superAdmin = false }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const navigation = superAdmin ? superNavigation : instituteNavigation;
  const title = useMemo(() => resolveTitle(location.pathname, navigation), [location.pathname, navigation]);
  return (
    <div className="app-shell">
      <SupportPresenceBridge superAdmin={superAdmin && location.pathname.startsWith('/superadmin/support-chat')}/>
      <Sidebar navigation={navigation} superAdmin={superAdmin} open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <main className="main-shell">
        <Topbar title={title} superAdmin={superAdmin} onMenu={() => setSidebarOpen(true)} />
        <div className="page-container"><Outlet /></div>
        {!superAdmin&&<FloatingSupportChat/>}
      </main>
    </div>
  );
}
